 
export type AnalyticEventCategory =
  | 'unknown'
  | 'click'
  | 'error'
  | 'warning'
  | 'focus'
  | 'load'
  | 'submit'

export function dispatchAnalyticEvent(
  event: string,
  category: AnalyticEventCategory,
  component: string,
  additionalProperties?: Record<string, any>,
) {
  try {
    const processedProperties: Record<string, any> = {}

    if (additionalProperties) {
      // ensure all properties are prefixed with 'ascend.'
      for (const [key, value] of Object.entries(additionalProperties)) {
        const processedKey = key.startsWith('ascend.') ? key : `ascend.${key}`
        processedProperties[processedKey] = value
      }
    }

    const analyticsEvent = new CustomEvent('aaAnalyticEvent', {
      detail: {
        event: event,
        'ascend.category': category,
        'ascend.component': component,
        ...processedProperties,
      },
      bubbles: true,
    })
    document.dispatchEvent(analyticsEvent)
  } catch (error) {
    console.warn('Error dispatching analytic event:', error)
  }
}
